import React from "react";
import Modal from "@mui/material/Modal";
import { motion } from "framer-motion";

// ModalWrapper's look on MUI Modal, which develop's carrier dialogs used: Esc closes,
// focus stays inside and returns to the trigger, the page behind doesn't scroll, and a
// drag that starts inside the box and ends on the backdrop doesn't close it.
const CarrierModal = ({ onClose, boxClassName = "", children }) => (
  <Modal
    open
    onClose={onClose}
    sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    slotProps={{
      backdrop: {
        transitionDuration: 0,
        sx: { backgroundColor: "rgba(0, 0, 0, 0.1)", backdropFilter: "blur(4px)" },
      },
    }}
  >
    <motion.div
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`bg-ui-surface p-6 rounded-lg w-96 border border-ui-border m-2 outline-none ${boxClassName}`}
    >
      {children}
    </motion.div>
  </Modal>
);

export default CarrierModal;
